import {createSvgIcon} from '../create-svg-icon';

export const AirlinesIcon = createSvgIcon(
  <path d="M17.34 18H5.8l8.25-12h5.54l-2.25 12zM13 4 2 20h17l3-16h-9zm1.5 5c-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5S15.88 9 14.5 9z" />
, 'AirlinesOutlined');
